export function isLengthAtLeast(array, length) {
    return array.length >= length;
}
